import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'ptl-card-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card-image.component.html',
  styleUrls: ['./card-image.component.scss'],
})
export class CardImageComponent {
  src = input<string>();
  alt = input<string>('');
  cardIndex = input(0);

  imageSrc = computed(() => {
    return this.src() || '/assets/card-placeholders/card-placeholder-' + ((this.cardIndex() % 4) + 1) + '.png';
  });
}
